<template>
  <div class="header">
    <div class="logo">
      <router-link to="/">
        <img src="@/assets/images/new-img/logo.jpg" />
      </router-link>
    </div>
    <div class="nav">
      <ul>
        <li>
          <router-link to="/">首页</router-link>
        </li>
        <li>
          <router-link to="/download_app">美菜商城</router-link>
        </li>
        <li>
          <router-link to="/cooperation">平台合作</router-link>
        </li>
        <!--
        <li class="platform">
          <a :class="{ 'router-link-exact-active': platformActivation }">平台合作</a>
          <i></i>
          <div class="classify">
            <span><router-link to="/partner">城市代理商</router-link></span>
            <span><router-link to="/county">县域招募</router-link></span>
            <span><router-link to="/cooperation">供应商合作</router-link></span>
            <span><router-link to="/driver">司机报名</router-link></span>
          </div>
        </li>
        -->
        <!-- <li>
          <router-link to="/company">公司简介</router-link>
        </li> -->
        <li>
          <router-link to="/information">新闻资讯</router-link>
        </li>
        <li>
          <router-link to="publicWelfare">最美菜公益</router-link>
        </li>
        <!--
        <li class="platform">
          <a :class="{ 'router-link-exact-active': platformActivation }">美菜招聘</a>
          <i></i>
          <div class="classify">
            <span><a href="https://meicai.zhiye.com/" target="_blank">社会招聘</a></span>
            <span><a href="http://campus.meicai.cn" target="_blank">校园招聘</a></span>
          </div>
        </li>
        -->
      </ul>
    </div>
    <a class="service-tel" :href="'tel:' + ($concatPhone || '4006-135-135')" id="service-tel">
      <span class="phone-symbol" aria-hidden="true">◔</span>{{ $concatPhone || "4006-135-135" }}
    </a>
  </div>
</template>

<script>
export default {
  name: "HomeHeader",
  data() {
    return {
      showTel: false,
      platformActivation: "",
    };
  },
  methods: {
    scrollHeader() {
      let top = document.documentElement.scrollTop + 60;
      let _w =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (top < _w) {
        this.showTel = false;
      } else {
        this.showTel = true;
      }
    },
    resetHeader(currentRoute) {
      if (currentRoute === "/") {
        this.showTel = false;
        document.addEventListener("scroll", this.scrollHeader);
      } else {
        this.showTel = true;
        document.removeEventListener("scroll", this.scrollHeader);
      }
      if (
        currentRoute == "/partner" ||
        currentRoute == "/county" ||
        currentRoute == "/cooperation" ||
        currentRoute == "/driver"
      ) {
        this.platformActivation = true;
      } else {
        this.platformActivation = false;
      }
      this.$on("hook:destroyed", () => {
        document.removeEventListener("scroll", this.scrollHeader);
      });
    },
  },
  watch: {
    "$route.path": {
      handler: "resetHeader",
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  z-index: 99;
  display: grid;
  width: 100%;
  min-width: 0;
  height: 60px;
  padding: 0 clamp(36px, 5vw, 72px);
  align-items: center;
  grid-template-columns: 120px 1fr 150px;
  background: rgba(255, 255, 255, .95);
  border-bottom: 1px solid rgba(19, 34, 25, .07);
  box-sizing: border-box;
  backdrop-filter: blur(18px);
  *, &::before, &::after { box-sizing: border-box; }
  /* Legacy fixed/floating header styles retained below have been replaced by the Demo grid layout. */
  /*
  background: #fff;
  height: 60px;
  position: fixed;
  width: 100%;
  min-width: 1200px;
  z-index: 99;
  border-bottom: 1px solid #d8d8d8;
  */
  .logo {
    float: none;
    width: 90px;
    height: 50px;
    margin: 0;
    overflow: hidden;
    img {
      display: block;
      width: 90px;
      height: 50px;
      object-fit: contain;
    }
  }
  .nav {
    float: none;
    height: 100%;
    margin: 0;
    ul {
      display: flex;
      height: 100%;
      margin: 0;
      padding: 0;
      align-items: stretch;
      justify-content: center;
      gap: clamp(24px, 3vw, 46px);
      li {
        position: relative;
        display: flex;
        height: 100%;
        padding: 0;
        align-items: stretch;
        font-size: 15px;
        line-height: normal;
        .letrit {
          border-left: 1px solid #d8d8d8;
          border-right: 1px solid #d8d8d8;
        }
        .classify {
          position: absolute;
          top: 59px;
          left: -1px;
          border: 1px solid #d8d8d8;
          border-top: 0;
          width: 119px;
          background: #fff;
          display: none;
          span {
            display: block;
            line-height: 42px;
            text-align: center;
            a {
              padding: 0;
              line-height: 42px;
              &:hover {
                background: #f8f8f8;
                display: block;
              }
            }
          }
        }
      }
      .platform {
        border-left: 1px solid transparent;
        border-right: 1px solid transparent;
        position: relative;
        padding: 0;
        line-height: 0;
        a {
          padding: 0 33px 0 20px;
          line-height: 60px;
          display: block;
        }
        &:hover i {
          transform: rotateZ(180deg);
        }
        &:hover .classify {
          display: block;
        }
        i {
          background: url(../assets/images/new-img/arrow-icon.png) no-repeat;
          background-size: 9px 6px;
          width: 9px;
          height: 6px;
          position: absolute;
          top: 27px;
          right: 18px;
          transition: transform 0.3s;
        }
      }
    }
    a {
      position: relative;
      display: flex;
      height: 100%;
      align-items: center;
      color: #333;
      white-space: nowrap;
      text-decoration: none;
      &::after {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 24px;
        height: 3px;
        transform: translateX(-50%) scaleX(0);
        background: #68ad25;
        content: "";
        transition: transform .24s ease;
      }
      &:hover {
        color: #173f24;
        &::after { transform: translateX(-50%) scaleX(1); }
      }
    }
    .router-link-exact-active {
      color: #173f24;
      &::after { transform: translateX(-50%) scaleX(1); }
    }
  }
}
.service-tel {
  display: flex;
  height: 24px;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  color: #ef6b42;
  border-radius: 999px;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-decoration: none;
  white-space: nowrap;
  .phone-symbol {
    display: inline-flex;
    width: 22px;
    height: 22px;
    align-items: center;
    justify-content: center;
    border: 2px solid currentColor;
    border-radius: 50%;
    color: #bde66e;
    font-size: 12px;
    line-height: 18px;
  }
  &:hover { color: #df542c; }
}

@media (max-width: 1080px) {
  .header {
    padding-right: 24px;
    padding-left: 24px;
    grid-template-columns: 100px minmax(0, 1fr) 125px;
    .nav {
      min-width: 0;
      overflow: hidden;
    }
    .nav ul {
      gap: 22px;
      justify-content: center;
      overflow-x: auto;
      scrollbar-width: none;
      &::-webkit-scrollbar { display: none; }
      li { display: flex; flex: 0 0 auto; }
    }
    .service-tel { gap: 8px; font-size: 14px; }
  }
}

@media (max-width: 720px) {
  .header {
    height: 62px;
    padding-right: 14px;
    padding-left: 14px;
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 12px;
    .logo, .logo img { width: 72px; height: 46px; }
    .nav {
      min-width: 0;
      overflow: hidden;
      ul {
        gap: 20px;
        justify-content: flex-start;
        overflow-x: auto;
        scrollbar-width: none;
        &::-webkit-scrollbar { display: none; }
        li { display: flex; flex: 0 0 auto; }
        li { font-size: 12px; }
      }
    }
    .service-tel { display: none; }
  }
}
</style>
